// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"25046e6d","44":"77e616fb","345":"bd6e2652","705":"0d6194ab"}[chunkId] + ".chunk.css";
};